import { FileEntryBM, LucideIconName } from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

type Props = {
  file: FileEntryBM
  className?: string
}

const DocumentCard = ({ file, className }: Props) => {
  return (
    <div
      className={`flex w-full items-center gap-4 rounded border border-solid border-gray-500 px-4 py-2 ${className}`}
    >
      <Icon name={LucideIconName.FileText} className='size-8' />
      <p className='font-semibold'>{file.name}</p>
    </div>
  )
}

export default DocumentCard
